import React from 'react'

type LabFlaskIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const LabFlaskIcon = ({ width = 20, height = 20, className, color = 'currentColor' }: LabFlaskIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.1945 12.0371H8.2026M13.6911 14.8053H13.6992M11.4001 15.1872H11.4082M7.8682 16.3644H7.8763M10.9285 17.1451H10.9366M16.167 12.8191C16.167 16.225 13.4059 18.986 10 18.986C6.5941 18.986 3.833 16.225 3.833 12.8191C3.833 9.8914 5.873 7.4403 8.609 6.8096V1.9037L7.9642 1.9027C7.9182 1.9027 7.8809 1.8654 7.8809 1.8194V1.0974C7.8809 1.0513 7.9182 1.014 7.9642 1.014H12.0358C12.0818 1.014 12.1191 1.0513 12.1191 1.0974V1.8194C12.1191 1.8654 12.0818 1.9027 12.0358 1.9027L11.391 1.9037V6.8096C14.127 7.4403 16.167 9.8914 16.167 12.8191Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
